<div class="modal-header">
  <h4 class="modal-title pull-left">{{ (isModif ? 'MINE_TRACKER.EDIT' : 'MINE_TRACKER.CREATE') | translate }}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="close()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="modal-content">
    <form id="ngForm" #ngForm="ngForm" (ngSubmit)="onSubmit()">
      
      <div class="form-group">
        <label for="name">{{'MINE_TRACKER.NAME' | translate}}</label>
        <input 
          [(ngModel)]="selectedApiKey.name" 
          id="name" 
          #name="ngModel" 
          type="text" 
          name="name" 
          class="form-control" 
          placeholder="{{'MINE_TRACKER.NAME_PLACEHOLDER' | translate}}" 
          [ngClass]="{'error-value': name.errors?.required && showError()}" 
          maxlength="150" 
          autocomplete="off" 
          required />
      </div>

      @if (!isModif) {
        <div class="form-group">
          <label for="expiresAt">{{'MINE_TRACKER.EXPIRES_AT' | translate}} ({{'MINE_TRACKER.OPTIONAL' | translate}})</label>
          <div class="input-group">
            <input 
              placeholder="{{'MINE_TRACKER.EXPIRES_AT_PLACEHOLDER' | translate}}"
              type="text"
              class="form-control"
              [(ngModel)]="expirationDate"
              name="expiresAt"
              [matDatepicker]="expiresAtPicker"
              [min]="minDate"
              onkeydown="return false"
              (click)="expiresAtPicker.open()"
              (focus)="expiresAtPicker.open()"
              readonly
              autocomplete="off">
            <mat-datepicker #expiresAtPicker></mat-datepicker>
            @if (expirationDate) {
              <div class="input-group-prepend">
                <button type="button" class="btn btn-outline-primary" (click)="nettoyerDates()">
                  <i class="fas fa-eraser"></i>
                </button>
              </div>
            }
          </div>
          <small class="form-text text-muted">{{'MINE_TRACKER.EXPIRATION_HELP' | translate}}</small>
        </div>
      }

    </form>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group" role="group">
    <button form="ngForm" type="submit" class="btn btn-outline-success">
      {{'GLOBAL.VALIDER' | translate}}
    </button>
  </div>
  <div class="btn-group" role="group">
    @if (isModif) {
      <button class="btn btn-outline-danger" style="margin-right:0.25rem;" (click)="delete()">
        {{'GLOBAL.SUPPRIMER' | translate}}
      </button>
    }
    <button type="button" class="btn btn-secondary" (click)="close()">
      {{'GLOBAL.FERMER' | translate}}
    </button>
  </div>
</div>
